import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import {SellerEntitiesFactory} from '../Entities/factory.js'
import {SellerErrorsFactory} from '../Errors/factory.js'
import {SellerMappersFactory} from '../Mappers/factory.js'
import {SellerValueObjectsFactory} from '../ValueObjects/factory.js'
import {EmptySellerRepository} from './EmptySellerRepository.js'
import {HTTPSellerRepository} from './HTTPSellerRepository.js'
import {LocalStorageSellerRepository} from './LocalStorageSellerRepository.js'

export class SellerRepositoriesFactory {
  /**
   * @return {LocalStorageSellerRepository}
   */
  static localStorageSellerRepository = ({config}) => {
    return new LocalStorageSellerRepository({
      config,
      localStorage,
      contactDetailsVOFactory: SellerValueObjectsFactory.contactDetailsValueObject,
      instantOfferEntityFactory: SellerEntitiesFactory.instantOfferSellerEntity
    })
  }

  /**
   * @return {EmptySellerRepository}
   */
  static emptySellerRepository = () => new EmptySellerRepository()

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {HTTPSellerRepository}
   * @property {Config} config
   * @property {Fetcher} fetchOrFail
   * @property {Function} confirmAppointmentGenericSellerErrorFactory
   */
  static hTTPSellerRepository = ({config}) =>
    new HTTPSellerRepository({
      authenticationFetcher: FetcherFactory.httpAuthenticationFetcher({config}),
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      makeLeadResponseToContactModelSellerResponseVOMapper:
        SellerMappersFactory.makeLeadResponseToContactModelSellerResponseVOMapper(),
      closeDealersResponseToVOMapper: SellerMappersFactory.closeDealersResponseToValueObjectSellerMapper({
        config
      }),
      confirmAppointmentGenericSellerErrorFactory: SellerErrorsFactory.confirmAppointmentGenericSellerError,
      contactModelSellerErrorFactory: SellerErrorsFactory.contactModelSellerGenericError,
      getCloseDealersGenericErrorFactory: SellerErrorsFactory.getCloseDealersGenericSellerError,
      getCloseDealersNotFoundErrorFactory: SellerErrorsFactory.getCloseDealersNotFoundSellerError,
      getInstantOfferDetailsGenericSellerErrorFactory: SellerErrorsFactory.getInstantOfferDetailsGenericSellerError,
      getInstantOfferDetailsNotFoundSellerErrorFactory: SellerErrorsFactory.getInstantOfferDetailsNotFoundSellerError,
      getInstantOfferGenericSellerErrorFactory: SellerErrorsFactory.getInstantOfferGenericSellerError,
      getInstantOfferNotFoundSellerErrorFactory: SellerErrorsFactory.getInstantOfferNotFoundSellerError,
      getRecommendedPriceGenericSellerErrorFactory: SellerErrorsFactory.getRecommendedPriceGenericSellerError,
      instantOfferSellerEntityFactory: SellerEntitiesFactory.instantOfferSellerEntity,
      recommendedPriceVOFactory: SellerValueObjectsFactory.recommendedPriceSellerValueObject,
      instantOfferSellerVOFactory: SellerValueObjectsFactory.instantOfferSellerValueObject
    })
}
